/* eslint-disable no-redeclare */
import { z } from 'zod';

import { CostModel, HtmlText, Integer, NonEmptyText, Url } from '../primitive';

export const FeaturedAd = z.object({
  id: NonEmptyText,
  logo: Url,
  title: NonEmptyText,
  content: HtmlText,
  provider: z.object({
    id: Integer,
    name: NonEmptyText,
    displayUrl: z.string(),
  }),
  link: Url,
  /**
   * @deprecated Use the provider.id instead, this field will be removed in the future.
   */
  creativeId: Integer,
  groupId: Integer,
  // TODO: move to an object with id or other more data
  campaignId: Integer,
  campaignName: NonEmptyText,
  dealType: CostModel,
  cpc: z.number(),
  adsSource: z.enum(['FeaturedAds', 'AdButler', 'MediaAlpha']).optional(),
});

export type FeaturedAd = z.infer<typeof FeaturedAd>;
